import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions';
import ErrorMsg from '../components/error-msg';





const mapStateToProps = (state, ownProps) => {
    
    return {
        globalError: state.globalError,
        globalMsg: state.globalMsg
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {


    };
};

const ErrorMsgContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ErrorMsg);


export default ErrorMsgContainer;